import axios, { AxiosInstance } from 'axios'

const apiInstance: AxiosInstance = axios.create()

export default apiInstance
